import type { TOC } from "@ember/component/template-only";
import mergeClasses from "glesys-controlpanel/modifiers/merge-classes";

const GroupLabel: TOC<{
  Args: object;
  Blocks: { default: [] };
  Element: HTMLDivElement;
}> = <template>
  <div class="px-2.5 py-2 text-xs text-gray-500" role="presentation" {{mergeClasses}} ...attributes>
    {{yield}}
  </div>
</template>;

export default GroupLabel;
